import { Button, Dialog, DialogTitle, makeStyles } from '@material-ui/core'
import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import QuestionHeader from './questionHeader'
import SignatureCanvas from 'react-signature-canvas'
import dayjs from 'dayjs'

const useStyles = makeStyles(() => ({
  all: {
    width: '100%',
    marginBottom: '10px'
  },
  button: {
    marginBottom: '10px',
    marginTop: '10px',
    backgroundColor: 'var(--button-color)',
    color: 'var(--button-text-color)',
    '&:hover': {
      backgroundColor: 'var(--button-color)',
    }
  },
}))

const numbers = [
  {
    val: `M105.317,5.056c-0.438-0.569-1.013-0.854-1.722-0.854h-3.276c-0.495,0-0.938,0.154-1.329,0.462
	c-0.57,0.439-0.855,1.013-0.855,1.722v5.46c0,0.494,0.154,0.938,0.463,1.33c0.438,0.569,1.013,0.854,1.722,0.854h3.276
	c0.494,0,0.938-0.153,1.33-0.461c0.568-0.439,0.854-1.014,0.854-1.723v-5.46C105.779,5.891,105.625,5.448,105.317,5.056z
	 M104.688,11.846c0,0.188-0.047,0.364-0.141,0.531c-0.205,0.374-0.521,0.561-0.951,0.561h-3.276c-0.187,0-0.364-0.047-0.532-0.14
	c-0.373-0.205-0.56-0.522-0.56-0.952v-5.46c0-0.187,0.047-0.364,0.14-0.532c0.205-0.373,0.523-0.56,0.952-0.56h3.276
  c0.187,0,0.363,0.046,0.531,0.14c0.374,0.206,0.561,0.523,0.561,0.952V11.846z`,
    offset: 0
  },

  {
    val: `M7.211,14.029c-0.261,0-0.434-0.121-0.518-0.363c-0.019-0.057-0.028-0.117-0.028-0.182v-3.277
	c0-0.261,0.121-0.433,0.364-0.517c0.056-0.019,0.117-0.028,0.182-0.028c0.261,0,0.434-0.122,0.518-0.364
	c0.019-0.056,0.028-0.117,0.028-0.182v-2.73c0-0.261-0.121-0.434-0.364-0.518L7.211,5.84c-0.261,0-0.434-0.121-0.518-0.364
	C6.675,5.42,6.666,5.359,6.666,5.294V4.748c0-0.262,0.121-0.435,0.364-0.519c0.056-0.019,0.117-0.028,0.182-0.028h1.092
	c0.261,0,0.434,0.122,0.518,0.364L8.85,4.748v4.368c0,0.261,0.121,0.434,0.364,0.518C9.27,9.652,9.33,9.662,9.396,9.662h1.092
  c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182v3.277c0,0.261-0.121,0.434-0.364,0.518l-0.182,0.027H7.211z`,
    offset: 190
  },

  {
    val: `M17.739,14.029l-0.014-0.014c-0.252,0-0.42-0.117-0.504-0.35c-0.019-0.057-0.028-0.117-0.028-0.182V9.116
	c0-0.261,0.121-0.434,0.364-0.518c0.056-0.019,0.117-0.028,0.182-0.028h2.184c0.261,0,0.434-0.121,0.518-0.363
	c0.019-0.056,0.028-0.117,0.028-0.182V5.84c0-0.261-0.121-0.434-0.364-0.518l-0.182-0.028h-2.184c-0.261,0-0.434-0.122-0.518-0.364
	c-0.019-0.056-0.028-0.117-0.028-0.182c0-0.262,0.121-0.435,0.364-0.519c0.056-0.019,0.117-0.028,0.182-0.028h3.276
	c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182v4.368c0,0.261-0.121,0.434-0.364,0.518l-0.182,0.028h-2.184
	c-0.262,0-0.435,0.122-0.519,0.364l-0.028,0.182v2.185c0,0.262,0.122,0.435,0.364,0.519c0.056,0.019,0.116,0.027,0.182,0.027h2.184
  c0.261,0,0.434,0.121,0.518,0.364c0.019,0.056,0.028,0.116,0.028,0.183c0,0.261-0.121,0.434-0.364,0.518l-0.182,0.027H17.739z`,
    offset: 170
  },

  {
    val: `M27.174,14.029c-0.262,0-0.435-0.121-0.519-0.363c-0.019-0.057-0.028-0.117-0.028-0.182c0-0.262,0.122-0.435,0.364-0.519
	c0.056-0.019,0.116-0.028,0.182-0.028h2.184c0.261,0,0.434-0.121,0.518-0.363c0.019-0.057,0.028-0.117,0.028-0.183v-2.185
	c0-0.261-0.122-0.433-0.364-0.517l-0.182-0.028h-2.184c-0.262,0-0.435-0.122-0.519-0.364c-0.019-0.056-0.028-0.117-0.028-0.182
	c0-0.261,0.122-0.434,0.364-0.518c0.056-0.019,0.116-0.028,0.182-0.028h2.184c0.261,0,0.434-0.121,0.518-0.363
	c0.019-0.056,0.028-0.117,0.028-0.182V5.84c0-0.261-0.122-0.434-0.364-0.518l-0.182-0.028h-2.184c-0.262,0-0.435-0.122-0.519-0.364
	c-0.019-0.056-0.028-0.117-0.028-0.182c0-0.262,0.122-0.435,0.364-0.519c0.056-0.019,0.116-0.028,0.182-0.028h3.276
	c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182v3.821c0,0.262,0.122,0.435,0.364,0.519c0.056,0.019,0.117,0.028,0.182,0.028
  c0.261,0,0.434,0.121,0.518,0.364l0.028,0.182v3.823c0,0.261-0.121,0.434-0.364,0.518l-0.182,0.027H27.174z`,
    offset: 150
  },

  {
    val: `M40.978,14.029c-0.261,0-0.434-0.121-0.518-0.363c-0.019-0.057-0.028-0.117-0.028-0.182v-1.093
	c0-0.261-0.122-0.434-0.364-0.518l-0.182-0.028h-3.276c-0.261,0-0.434-0.121-0.518-0.364c-0.019-0.056-0.028-0.116-0.028-0.182
	V4.748c0-0.262,0.121-0.435,0.364-0.519c0.056-0.019,0.117-0.028,0.182-0.028h1.092c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182
	v5.459c0,0.262,0.121,0.436,0.364,0.52c0.056,0.018,0.117,0.027,0.182,0.027h1.092c0.261,0,0.434-0.121,0.518-0.364
	c0.019-0.056,0.028-0.116,0.028-0.183c0-0.261,0.121-0.433,0.364-0.517c0.056-0.019,0.117-0.028,0.182-0.028h1.092
  c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182v3.277c0,0.261-0.122,0.434-0.364,0.518l-0.182,0.027H40.978z`,
    offset: 130
  },
  {
    val: `M48.229,14.029c-0.262,0-0.435-0.121-0.519-0.363c-0.019-0.057-0.028-0.117-0.028-0.182c0-0.262,0.122-0.435,0.364-0.519
	c0.056-0.019,0.116-0.028,0.182-0.028h3.276c0.261,0,0.434-0.121,0.518-0.363c0.019-0.057,0.028-0.117,0.028-0.183v-2.185
	c0-0.261-0.121-0.433-0.364-0.517l-0.182-0.028h-3.276c-0.262,0-0.435-0.122-0.519-0.364c-0.019-0.056-0.028-0.117-0.028-0.182
	V4.748c0-0.262,0.122-0.435,0.364-0.519c0.056-0.019,0.116-0.028,0.182-0.028h4.368c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182
	c0,0.261-0.122,0.434-0.364,0.518l-0.182,0.028h-3.276c-0.261,0-0.434,0.121-0.518,0.364L48.775,5.84v2.184
	c0,0.261,0.121,0.434,0.364,0.518c0.056,0.019,0.117,0.027,0.182,0.027h3.276c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182v4.369
  c0,0.261-0.122,0.434-0.364,0.518l-0.182,0.027H48.229z`,
    offset: 110
  },
  {
    val: `M63.642,10.025c-0.084-0.242-0.257-0.364-0.518-0.364h-4.368c-0.066,0-0.126-0.009-0.182-0.028
	C58.332,9.55,58.21,9.377,58.21,9.116V5.84l0.028-0.182c0.084-0.243,0.257-0.364,0.519-0.364h1.092l0.182,0.028
	c0.243,0.084,0.364,0.257,0.364,0.518v0.546c0,0.065,0.009,0.126,0.028,0.182c0.084,0.243,0.257,0.364,0.519,0.364l0.182-0.028
	c0.243-0.084,0.364-0.257,0.364-0.518V4.748l-0.028-0.182c-0.084-0.243-0.256-0.364-0.518-0.364h-3.276
	c-0.065,0-0.126,0.009-0.182,0.028c-0.243,0.084-0.364,0.257-0.364,0.519v8.736c0,0.064,0.009,0.125,0.028,0.182
	c0.083,0.242,0.256,0.363,0.518,0.363h5.46l0.182-0.027c0.242-0.084,0.364-0.257,0.364-0.518v-3.277L63.642,10.025z M62.578,12.392
	c0,0.065-0.009,0.126-0.028,0.183c-0.084,0.242-0.257,0.363-0.518,0.363h-3.276c-0.066,0-0.126-0.009-0.182-0.027
	c-0.243-0.084-0.364-0.257-0.364-0.519V11.3c0-0.065,0.009-0.126,0.028-0.183c0.084-0.242,0.257-0.363,0.519-0.363h3.276
  l0.182,0.027c0.243,0.084,0.364,0.258,0.364,0.519V12.392z`,
    offset: 90
  },
  {
    val: `M71.468,14.029c-0.262,0-0.435-0.121-0.519-0.363c-0.019-0.057-0.028-0.117-0.028-0.182V9.116
	c0-0.243,0.112-0.411,0.336-0.504l1.512-0.63c0.224-0.093,0.336-0.261,0.336-0.503V5.84c0-0.261-0.121-0.434-0.364-0.518
	L72.56,5.294h-2.184c-0.261,0-0.434,0.121-0.518,0.364L69.83,5.84v1.092c0,0.261-0.122,0.434-0.364,0.518l-0.182,0.028
	c-0.262,0-0.435-0.122-0.519-0.364c-0.019-0.056-0.028-0.117-0.028-0.182V4.748c0-0.262,0.122-0.435,0.364-0.519
	c0.056-0.019,0.116-0.027,0.182-0.028h4.368c0.261,0,0.434,0.122,0.518,0.364l0.028,0.182V8.22c0,0.243-0.112,0.411-0.336,0.504
  L72.35,9.326c-0.224,0.094-0.336,0.262-0.336,0.504v3.654c0,0.261-0.122,0.434-0.364,0.518L71.468,14.029z`,
    offset: 70
  },
  {
    val: `M84.697,9.479c-0.084-0.243-0.257-0.364-0.518-0.364c-0.065,0-0.126-0.009-0.182-0.028
	c-0.242-0.084-0.364-0.257-0.364-0.519V4.748l-0.028-0.182c-0.084-0.243-0.257-0.364-0.518-0.364h-4.368
	c-0.065,0-0.126,0.009-0.182,0.028c-0.243,0.084-0.364,0.257-0.364,0.519v3.821c0,0.066-0.009,0.126-0.028,0.182
	c-0.083,0.243-0.256,0.364-0.518,0.364c-0.065,0-0.126,0.009-0.182,0.028c-0.243,0.084-0.364,0.257-0.364,0.518v3.823
	c0,0.064,0.01,0.125,0.028,0.182c0.084,0.242,0.257,0.363,0.518,0.363h6.552l0.182-0.027c0.242-0.084,0.364-0.257,0.364-0.518V9.662
	L84.697,9.479z M82.541,12.392c0,0.065-0.009,0.126-0.028,0.183c-0.084,0.242-0.256,0.363-0.518,0.363h-2.184
	c-0.066,0-0.126-0.009-0.182-0.027c-0.243-0.084-0.364-0.257-0.364-0.519v-2.185l0.028-0.182c0.084-0.242,0.257-0.364,0.519-0.364
	h2.184l0.182,0.028c0.243,0.084,0.364,0.256,0.364,0.517V12.392z M82.541,8.024c0,0.065-0.009,0.126-0.028,0.182
	c-0.084,0.242-0.256,0.363-0.518,0.363h-2.184c-0.066,0-0.126-0.009-0.182-0.027c-0.243-0.084-0.364-0.257-0.364-0.518V5.84
  l0.028-0.182c0.084-0.243,0.257-0.364,0.519-0.364h2.184l0.182,0.028c0.243,0.084,0.364,0.257,0.364,0.518V8.024z`,
    offset: 50
  },
  {
    val: `M95.225,4.566c-0.084-0.243-0.258-0.364-0.519-0.364h-5.46c-0.064,0-0.126,0.009-0.182,0.028
	C88.821,4.313,88.7,4.486,88.7,4.748v4.368c0,0.065,0.009,0.126,0.028,0.182c0.084,0.242,0.256,0.364,0.518,0.364h3.276l0.182,0.028
	c0.243,0.084,0.364,0.256,0.364,0.517v3.277c0,0.064,0.01,0.125,0.027,0.182c0.084,0.242,0.258,0.363,0.519,0.363h1.092l0.183-0.027
	c0.242-0.084,0.363-0.257,0.363-0.518V4.748L95.225,4.566z M94.16,8.024c0,0.065-0.01,0.126-0.027,0.182
	c-0.084,0.242-0.258,0.363-0.519,0.363h-3.276c-0.065,0-0.126-0.009-0.182-0.027c-0.242-0.084-0.364-0.257-0.364-0.518V5.84
  l0.028-0.182c0.084-0.243,0.256-0.364,0.518-0.364h3.276l0.183,0.028c0.242,0.084,0.363,0.257,0.363,0.518V8.024z`,
    offset: 30
  },
]

const checkTransit = [
  'M114.372,5.844h-1.275c-0.234,0-0.425,0.19-0.425,0.425v5.712c0,0.234,0.19,0.425,0.425,0.425h1.275 c0.234,0,0.425-0.19,0.425-0.425V6.269C114.797,6.034,114.606,5.844,114.372,5.844z',
  'M119.888,4.203h-2.4c-0.234,0-0.425,0.19-0.425,0.425v2.384c0,0.235,0.19,0.425,0.425,0.425h2.4 c0.234,0,0.425-0.19,0.425-0.425V4.628C120.312,4.394,120.122,4.203,119.888,4.203z',
  'M119.888,10.781h-2.4c-0.234,0-0.425,0.19-0.425,0.426v2.383c0,0.235,0.19,0.426,0.425,0.426h2.4 c0.234,0,0.425-0.19,0.425-0.426v-2.383C120.312,10.972,120.122,10.781,119.888,10.781z',
]

const checkOnUs = [
  'M128.367,5.854h-0.191c-0.234,0-0.425,0.19-0.425,0.425v5.67c0,0.234,0.19,0.425,0.425,0.425h0.191 c0.234,0,0.425-0.19,0.425-0.425V6.28C128.792,6.045,128.602,5.854,128.367,5.854z',
  'M130.514,5.854h-0.191c-0.234,0-0.425,0.19-0.425,0.425v5.67c0,0.234,0.19,0.425,0.425,0.425h0.191 c0.234,0,0.425-0.19,0.425-0.425V6.28C130.938,6.045,130.748,5.854,130.514,5.854z',
  'M134.909,4.729h-2.4c-0.234,0-0.425,0.19-0.425,0.425v3.524c0,0.235,0.19,0.425,0.425,0.425h2.4 c0.234,0,0.425-0.19,0.425-0.425V5.155C135.334,4.92,135.144,4.729,134.909,4.729z'
]

function checkChars(font, str) {
  const codes = font.getCharacterSet()
  let newStr = ''
  for (let i = 0; i < str.length; i++) {
    if (codes.indexOf(str.charCodeAt(i)) > -1) newStr += str[i]
    else newStr += ' '
  }
  return newStr
}

function replaceObjectWithChars(font, obj) {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[key] = checkChars(font, obj[key])
  })
  return newObj
}

export default function RenderTemplatePDF({ elmIndex, elm, valIndex, valueChange }) {
  const classes = useStyles()
  const [openSign, setOpenSign] = useState(false)
  const sigCanvas = useRef()
  const [content, setContent] = useState(null)
  useEffect(() => {
    async function go() {
      let fileURI
      if (elm.Template === 'voidCheck') {
        const url = 'https://storage.googleapis.com/horatio-project.appspot.com/public/check.pdf'
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
        elm.PDFVars = replaceObjectWithChars(helveticaFont, elm.PDFVars)
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]
        const { width, height } = firstPage.getSize()
        const routingArray = elm.PDFVars?.Routing?.split('') ?? []
        const accountArray = elm.PDFVars?.Account?.split('') ?? []

        const createTransit = (offset) => {
          firstPage.drawSvgPath(checkTransit[0] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
          firstPage.drawSvgPath(checkTransit[1] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
          firstPage.drawSvgPath(checkTransit[2] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
        }

        const createOnUs = (offset) => {
          firstPage.drawSvgPath(checkOnUs[0] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
          firstPage.drawSvgPath(checkOnUs[1] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
          firstPage.drawSvgPath(checkOnUs[2] ?? '', {
            x: -150 + (25 * (offset)),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
        }
        createTransit(-1)
        routingArray?.forEach((char, i) => {
          firstPage.drawSvgPath(numbers[parseInt(char)]?.val ?? '', {
            x: -110 + (25 * i) + (numbers[parseInt(char)]?.offset ?? 0),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
        })
        createTransit(routingArray.length + 1)
        accountArray?.forEach((char, i) => {
          firstPage.drawSvgPath(numbers[parseInt(char)]?.val ?? '', {
            x: ((routingArray.length + 3) * 25) + -110 + (25 * i) + (numbers[parseInt(char)]?.offset ?? 0),
            y: 70,
            scale: 2,
            color: rgb(0, 0, 0)
          })
        })
        createOnUs(routingArray.length + accountArray.length + 3)

        // Memo Line
        if (elm.PDFVars?.Memo) {
          firstPage.drawText(elm.PDFVars?.Memo, {
            x: 100,
            y: 98,
            size: 18,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }
        if (elm.PDFVars?.BankName) {
          firstPage.drawText(elm.PDFVars?.BankName, {
            x: 50,
            y: 180,
            size: 20,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }

        // Name and Address Line
        if (elm.PDFVars?.Name) {
          firstPage.drawText(elm.PDFVars?.Name, {
            x: 50,
            y: 450,
            size: 20,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }
        if (elm.PDFVars?.Address1) {
          firstPage.drawText(elm.PDFVars?.Address1, {
            x: 50,
            y: 430,
            size: 18,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }
        if (elm.PDFVars?.Address2) {
          firstPage.drawText(elm.PDFVars?.Address2, {
            x: 50,
            y: 410,
            size: 18,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }
        if (elm.PDFVars?.Phone) {
          firstPage.drawText(elm.PDFVars?.Phone, {
            x: 50,
            y: 390,
            size: 18,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
        }


        firstPage.drawText('VOID', {
          x: width / 2 - 250,
          y: height / 2 - 90,
          size: 200,
          font: helveticaFont,
          opacity: .5,
          color: rgb(0.95, 0.1, 0.1),
        })
        fileURI = await pdfDoc.saveAsBase64({ dataUri: true })
        setContent(<embed src={fileURI} type="application/pdf" className={classes.all} style={{ height: '500px' }} />)

      } else if (elm.Template === 'W9') {
        const url = 'https://storage.googleapis.com/horatio-project.appspot.com/public/fw9.pdf'
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
        elm.PDFVars = replaceObjectWithChars(helveticaFont, elm.PDFVars)
        const pdfForm = pdfDoc.getForm()
        const fields = pdfForm.getFields()

        fields[0].setText(elm?.PDFVars?.Name ?? '')
        fields[1].setText(elm?.PDFVars?.BusinessName ?? '')
        fields[13].setText(elm?.PDFVars?.Address ?? '')
        fields[14].setText(`${elm?.PDFVars?.City}, ${elm?.PDFVars?.State}, ${elm?.PDFVars?.ZIP}`)

        fields[15].setText(`${elm?.PDFVars?.RequesterName}
${elm?.PDFVars?.RequesterAddress}`)

        const SSN = (elm?.PDFVars?.SSN?.split('-').join('') ?? '').trim()
        fields[17].setText(SSN.substring(0, 3))
        fields[18].setText(SSN.substring(3, 5))
        fields[19].setText(SSN.substring(5, 9))

        const EIN = (elm?.PDFVars?.EIN?.split('-').join('') ?? '').trim()
        fields[20].setText(EIN.substring(0, 2))
        fields[21].setText(EIN.substring(2, 9))
        switch (elm?.PDFVars?.BusinessType) {
          case 'Partnership':
            fields[5].check()
            break
          case 'S Corporation':
            fields[4].check()
            break
          case 'C Corporation':
            fields[3].check()
            break
          case 'Sole Proprietor':
            fields[2].check()
            break
          default:
            fields[2].check()
            break
        }

        if (elm?.Value?.[valIndex]?.[0]?.Sig) {
          const firstPage = pdfDoc.getPages()[0]
          firstPage.drawText(elm?.Value?.[valIndex]?.[0]?.Date, {
            x: 430,
            y: 230,
            size: 15,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          })
          const jpgImage = await pdfDoc.embedPng(elm?.Value?.[valIndex]?.[0]?.Sig)
          const jpgDims = jpgImage.scale(0.1)

          firstPage.drawImage(jpgImage, {
            x: 130,
            y: 230,
            width: jpgDims.width,
            height: jpgDims.height,
          })
        }

        /*fields.map((field, i) => {
          //if (field.setText) field?.setText(`${i}`)
        })*/

        pdfForm.flatten()

        fileURI = await pdfDoc.saveAsBase64({ dataUri: true })
        setContent(<embed src={fileURI} type="application/pdf" className={classes.all} style={{ height: '1000px' }} />)
      }

    }
    go()

  }, [elm, valIndex])
  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={true} />
    {elm.Template === 'W9' && <>
      <Button size="large" className={classes.button} onClick={() => setOpenSign(true)}>Sign Document</Button>
      <Dialog open={openSign} onClose={() => setOpenSign(false)}>
        <DialogTitle>Sign on the pad below</DialogTitle>
        <SignatureCanvas penColor='black' ref={(ref) => { sigCanvas.current = ref }} canvasProps={{ width: 500, height: 200, style: { width: 500, height: 200, border: '1px black solid', margin: '30px' } }} />
        <Button onClick={() => sigCanvas.current.clear()}>Clear</Button>
        <Button onClick={() => {
          if (!confirm('Do you consent to sign this document electronically?')) return
          elm.Value[valIndex] = [{ Sig: sigCanvas.current.toDataURL('image/png'), Date: dayjs().format('MM/DD/YYYY') }]
          valueChange(elmIndex, valIndex, elm.Value[valIndex])
          setOpenSign(false)
          setTimeout(() => document.getElementById('save').click(), 500)
        }}>Save</Button>
      </Dialog>
    </>}
    {content ?? <></>}
  </div>
}

RenderTemplatePDF.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
}